import React, { useEffect, useState } from 'react'

import hubloIcon from '@assets/svg/icon-hublo.svg'
import { Box, Image, Stack, Text, useMediaQuery } from '@chakra-ui/react'
import { CtaButton, OutlinedButton } from '@components/ui/Button'
import Link from '@components/ui/Link'
import { HUBLO_URL } from '@helpers/url'
import { AiOutlineClose, AiOutlineMenu } from 'react-icons/ai'

import Logo from '../Logo'
import Section from '../Section'
import { ParadeBox } from './MenuHeader.style'
import NavBar from './NavBar'

const BannerItem = ({ icon }: { icon: string }) => (
    <Box display="flex" alignItems="center" gap={9}>
        <Text fontFamily="hublo" color="white" fontSize={{ base: 'md', md: 'xl' }} marginLeft={9}>
            Staffea devient
            <Text as="span" fontWeight="bold" color="hubloGreen">
                &nbsp;Hublo Planning
            </Text>
        </Text>

        <Image src={icon} maxW={{ base: '20px', xl: '30px' }} />

        <Text fontFamily="hublo" color="white" fontSize={{ base: 'xs', md: 'sm' }}>
            Rendez-vous sur
            <Text as="span" fontWeight="bold" color="hubloGreen">
                &nbsp;hublo.com
            </Text>
        </Text>

        <Image src={icon} maxW={{ base: '20px', md: '30px' }} />
    </Box>
)

const MenuToggle = ({ toggle, isOpen }: { toggle: () => void; isOpen: boolean }) => {
    return (
        <Box display="block" position="absolute" right="4" onClick={toggle}>
            {isOpen ? <AiOutlineClose size={24} /> : <AiOutlineMenu size={24} />}
        </Box>
    )
}

const MenuHeader = () => {
    const [isOpen, setOpen] = useState(false)
    const [isMobile, isDesktop] = useMediaQuery(['(max-width: 800px)', '(min-width: 1600px)'])
    const toggle = () => setOpen(!isOpen)

    useEffect(() => {
        if (!isMobile) {
            setOpen(false)
        }
    }, [isMobile])

    const repeat = isDesktop ? 6 : 3

    return (
        <Box position="sticky" top="0" width="100%" zIndex="10">
            <a href={HUBLO_URL} target="_blank" rel="noreferrer">
                <Box position="relative" width="100%" overflowX="hidden" bg="hubloBlue">
                    {isMobile ? (
                        <Box display="flex" padding={3} gap={5} justifyContent="center" alignItems="center">
                            <Image src={hubloIcon} maxW="35px" objectFit="cover" />

                            <Text fontFamily="hublo" color="white" fontSize="xl" textAlign="center" lineHeight="22px">
                                Staffea devient
                                <Text variant="bold" color="hubloGreen">
                                    &nbsp;Hublo Planning
                                </Text>
                            </Text>

                            <Image src={hubloIcon} maxW="35px" objectFit="cover" />
                        </Box>
                    ) : (
                        <Box
                            position="relative"
                            overflowX="hidden"
                            width="100%"
                            height="100%"
                            display="flex"
                            padding={3}
                        >
                            <ParadeBox>
                                {[...Array(repeat)].map((_, i) => (
                                    <BannerItem key={i} icon={hubloIcon} />
                                ))}

                                {[...Array(repeat)].map((_, i) => (
                                    <BannerItem key={`clone-${i}`} icon={hubloIcon} />
                                ))}
                            </ParadeBox>
                        </Box>
                    )}
                </Box>
            </a>

            <Section bg="indigo.100">
                <Box display="flex" justifyContent={isMobile ? 'center' : 'space-between'} alignItems="center" py="4">
                    <Link to="/">
                        <Logo width="150px" />
                    </Link>

                    {isMobile ? (
                        <MenuToggle toggle={toggle} isOpen={isOpen} />
                    ) : (
                        <Stack direction="row" align="center" spacing="6">
                            <NavBar direction="row" />

                            <a href="https://www.staffea.net" target="blank">
                                <OutlinedButton text="Se connecter" fontSize="14" />
                            </a>

                            <a href={HUBLO_URL} target="_blank" rel="noreferrer">
                                <CtaButton text="Nous contacter" height="10" textButtonFontSize="sm" />
                            </a>
                        </Stack>
                    )}
                </Box>

                <Box display={isMobile && isOpen ? 'block' : 'none'} py={4}>
                    <NavBar direction="column" />

                    <a href="https://www.staffea.net" target="blank">
                        <Box pt="16" pb="2" display="flex" alignItems="center" justifyContent="center">
                            <OutlinedButton text="Se connecter" fontSize="14" />
                        </Box>
                    </a>

                    <a href="/contact">
                        <Box pt="16" pb="2" display="flex" alignItems="center" justifyContent="center">
                            <CtaButton text="Nous contacter" height="10" textButtonFontSize="sm" />
                        </Box>
                    </a>
                </Box>
            </Section>
        </Box>
    )
}

export default MenuHeader
